export default {
  page_home: {
    en: 'About Us',
    fr: 'À propos',
  },
  page_members: {
    en: 'Members',
    fr: 'Membres',
  },
  page_partners: {
    en: 'Partners',
    fr: 'Partenaires',
  },
  page_join: {
    en: 'Join Us',
    fr: 'Rejoins-nous',
  },
  language: {
    en: 'Language',
    fr: 'Langue',
  },
};
